<sb-checklist-footer
  [title]="'📞 ' + ('Book a call' | translate)"
  [subtitle]="'We\'re here to help you get set up fast. Pick a time that works for a quick demo.' | translate"
  [primaryBtnLabel]="'Book a call' | translate"
  [secondaryBtnLabel]="'I don\'t need help' | translate"
  (primary)="onPrimaryClick()"
  (secondary)="onSecondaryClick()"
/>
